import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import FNOLHOTFPAWizard from './FNOLHOTFPAWizard';
// import FNOLCriminalDamagePage from './pages/CriminalDamage/CriminalDamagePage';
// import FNOLFireDamagePage from './pages/FireDamage/FireDamagePage';
// import FNOLHOTypeOfIncidentPage from './pages/TypeOfIncident/TypeOfIncidentPage';
// import FNOLWaterDamagePage from './pages/WaterDamage/WaterDamagePage';

setComponentMapOverrides(
    {
        FNOLHOTFPAWizard: { component: 'FNOLHOTFPAWizard' },
    },
    {
        FNOLHOTFPAWizard,
    }
);

export { FNOLHOTFPAWizard as default };
